import { Flex } from "@similarweb/ui-components/foundations";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { StyledErrorImage, StyledSubTitle, StyledTitle } from "./styles";

const OnboardingErrorContent = () => {
    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap="16px"
            width="100%"
        >
            <StyledErrorImage iconName="no-data-tree" />
            <CenteredFlexColumn>
                <I18n
                    element={StyledTitle}
                    translatable={{ key: "si.onboarding.error.title" }}
                />
                <I18n
                    element={StyledSubTitle}
                    translatable={{ key: "si.onboarding.error.subtitle" }}
                />
            </CenteredFlexColumn>
        </Flex>
    );
};

export default OnboardingErrorContent;
